module.exports = [{
      plugin: require('/Users/duc/Documents/carousell/newPricelist/node_modules/gatsby-plugin-typography/gatsby-browser'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('/Users/duc/Documents/carousell/newPricelist/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[],"trackingId":"UA-132076253-1"},
    },{
      plugin: require('/Users/duc/Documents/carousell/newPricelist/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
